import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import host from '../../urlPath';
//******* 
 
 

//--------- INSERT
export const addParticipate = createAsyncThunk("addParticipate", async (data, { rejectWithValue }) => {
    const response = await fetch(`${host}/group_add_participate.php`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    try {
        const result = await response.json();
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})


 


//--------- UPDATE
export const removeParticipate = createAsyncThunk("removeParticipate", async (id, { rejectWithValue }) => {
     const response = await fetch(`${host}/group_add_participate2.php/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
    });
    try {
        const result = await response.json();
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})


//=---------- READ
export const showClientData = createAsyncThunk("showClientData", async (data, { rejectWithValue }) => {
     const response = await fetch(`${host}/group_add_participate2.php`, {
        method: "POST", // *GET, POST, PUT, DELETE, etc. 
        headers: {
            "Content-Type": "application/json"
        },  
        body: JSON.stringify(data),
    });
    try {
        const result = await response.json();
        return result;

    } catch (error) {
        return rejectWithValue(error)
    }
})
 
 



//*************************************** FOR API END *************************


export const groupAddParticipate = createSlice({
    name: "groupAddParticipate",
    initialState: {
        clientNonParticipate: [],
        clientParticipate: [],
        clientID: [], 
        loading: false,
        error: null 
    },
     

    // //*************************************** FOR WITHOUT API ONLY FUNCTION START *************************   
    reducers: {
        setClientId: (state, action) => { 
            if (action.payload === "") {
                state.clientID = [];
            }
            else if (state.clientID.includes(action.payload)) {
                const index = state.clientID.indexOf(action.payload);
                state.clientID.splice(index, 1);
            } else {
                state.clientID.push(action.payload)
            }
        },
    },
    //*************************************** FOR WITHOUT API ONLY FUNCTION END *************************



    //*************************************** FOR API START *************************
    extraReducers: (builder) => {
  

        //---------------------- FOR ADD ---------------------------
         builder.addCase(addParticipate.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(addParticipate.fulfilled, (state) => {
            state.loading = false;   
            
        })
        builder.addCase(addParticipate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------


        //---------------------- FOR DELETE ---------------------------
        builder.addCase(removeParticipate.pending, (state) => {
        state.loading = true;
        })
        builder.addCase(removeParticipate.fulfilled, (state) => {
            state.loading = false; 
        })
        builder.addCase(removeParticipate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------


        //---------------------- FOR SELECT ---------------------------
        builder.addCase(showClientData.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(showClientData.fulfilled, (state, action) => {
            state.loading = false;
            state.clientNonParticipate = action.payload[0].clientnonparticipate
            state.clientParticipate = action.payload[1].clientparticipate 
        })
        builder.addCase(showClientData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------
  
        //*************************************** FOR API END ************************* 
    },

});
export default groupAddParticipate.reducer;
export const {setClientId} = groupAddParticipate.actions; // FOR EXPORT REDUCERS